// third-party
import { FormattedMessage } from 'react-intl';


// type
import { NavItemType } from 'types/menu';
// assets
import { DeviceMessage ,Chart1,ChartFail,Chart2} from 'iconsax-react';

// icons
const icons = {
  leads:DeviceMessage,
  purchase:Chart1,
  expenses:ChartFail,
  jobs:Chart2
};

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //

const reports: NavItemType = {
  id: 'group-reports',
  title: <FormattedMessage id="reports"  />,
  icon: icons.jobs,
  type: 'collapse',
  permissions:['NL_REPORTS_R'],
  children:[
    {
        id: 'jobs-report',
        title: <FormattedMessage id="project-report" />,
        type: 'item',
        url: '/reports/project',
        icon: icons.jobs,
        breadcrumbs: false,
         permissions:['NL_REPORTS_PROJECTS_R'],
      },
      {
        id: 'accounts-report',
        title: <FormattedMessage id="profit-loss-analysis" />,
        type: 'item',
        url: '/reports/accounts',
        icon: icons.purchase,
        breadcrumbs: false,
         permissions:['NL_REPORTS_ACCOUNTS_R'],
      },
        {
        id: 'invoice-report',
        title: <FormattedMessage id="invoice-reports" />,
        type: 'item',
        url: '/reports/invoice',
        icon: icons.expenses,
        breadcrumbs: false,
         permissions:['NL_REPORTS_INVOICE_R'],
      },
      // {
      //   id: 'leads-report',
      //   title: <FormattedMessage id="leads-report" />,
      //   type: 'item',
      //   url: '/reports/leads',
      //   icon: icons.leads,
      //   breadcrumbs: false
      // },
      // {
      //   id: 'expenses-report',
      //   title: <FormattedMessage id="expenses-report" />,
      //   type: 'item',
      //   url: '/reports/expenses',
      //   icon: icons.expenses,
      //   breadcrumbs: false
      // }
  ]
};

export default reports;
